import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TripOriginRoundedIcon from "@mui/icons-material/TripOriginRounded";

// Web hailing's copy of the web receipt's pickup/drop-off card (web-receipt/PoiInfoCard).
// A copy, so receipt changes do not reach the tracker.
export interface TripPlacesCardProps {
  pickupTime: string;
  pickupName: string;
  pickupAddress: string;
  dropoffName: string;
  dropoffAddress: string;
}

const TripPlacesCard: React.FC<TripPlacesCardProps> = ({
  pickupTime,
  pickupName,
  pickupAddress,
  dropoffName,
  dropoffAddress,
}) => (
  <div className="w-full flex flex-col items-stretch">
    <div className="rounded-lg p-4 flex flex-col gap-2 mx-5 mt-2 mb-2 max-w-full bg-white">
      <div className="flex flex-col gap-0">
        <div className="flex flex-row items-start">
          <div className="flex flex-col items-center min-w-[28px]">
            <span className="w-7 h-7 flex items-center justify-center">
              <TripOriginRoundedIcon sx={{ color: "#1479c7", fontSize: 20 }} />
            </span>
            <div className="border-l-2 border-dashed border-gray-400 h-10 mt-0.5 mb-0.5" />
          </div>
          <div className="flex flex-col justify-center pl-2 min-h-[28px]">
            <span className="text-sm font-normal leading-tight text-mineshaft-700">
              {pickupTime}
            </span>
            <span className="text-base font-semibold leading-tight text-mineshaft-900">
              {pickupName}
            </span>
            <div className="text-sm font-normal leading-tight text-mineshaft-700">
              {pickupAddress}
            </div>
          </div>
        </div>
        <div className="flex flex-row items-start mt-1">
          <div className="flex flex-col items-center min-w-[28px]">
            <span className="w-7 h-7 flex items-center justify-center">
              <LocationOnIcon sx={{ color: "#22b752", fontSize: 24 }} />
            </span>
          </div>
          <div className="flex flex-col justify-center pl-2 min-h-[28px]">
            <span className="text-base font-semibold leading-tight text-mineshaft-900">
              {dropoffName}
            </span>
            <div className="text-sm font-normal leading-tight text-mineshaft-700">
              {dropoffAddress}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TripPlacesCard;
